import type { CmsApiPageId } from 'modules/cms/api/types/CmsApiTypedId';

import { CmsLatestReactionAvatars } from './CmsLatestReactionAvatars';
import { CmsReactionsSummaryContainer } from './CmsReactions.styled';
import { CmsTotalReactionsHeading } from './CmsTotalReactionsHeading';

type Props = {
  contentId: CmsApiPageId;
};

export function CmsReactionsSummary({ contentId }: Props) {
  return (
    <CmsReactionsSummaryContainer>
      <CmsLatestReactionAvatars />
      <CmsTotalReactionsHeading contentId={contentId} />
    </CmsReactionsSummaryContainer>
  );
}
